import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String
  };

  get isDevEnvironment() {
    return document.head.querySelector("meta[name=rails_env]").content === "development"
  }

  connect() {
    console.log("Waffle chart controller connected");
    this.startAutoRefresh();
  }

  disconnect() {
    // Clear the interval when the controller is disconnected
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  startAutoRefresh() {
    if (this.isDevEnvironment) {
      console.log("Development environment detected, refreshing waffle chart in 1 minute...");
      this.refreshInterval = setInterval(() => {
        this.refreshChart();
      }, 60000); // Refresh every 60 seconds in development
    } else {
      this.refreshInterval = setInterval(() => {
        this.refreshChart();
      }, 10000); // Refresh every 10 seconds in production
    }
  }

  async refreshChart() {
    console.log("Refreshing waffle chart...");
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'Accept': 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      this.element.innerHTML = html;
    } catch (error) {
      console.error("Error refreshing waffle chart:", error);
    }
  }
}
